// src/pages/Home.js
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { AnimatePresence } from "framer-motion";

import closeIcon from "../assets/images/+.svg";
import logo from "../assets/images/Logo.svg";
import styles from "./HomePage.module.scss";

// Components
import FileUploadView from "../components/home/FileUploadView";
import BuildingTypeForm from "../components/home/BuildingTypeForm";
import TypeSelection from "../components/home/TypeSelection";

function Home() {
  const [currentBuildingType, setCurrentBuildingType] = useState(null);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showBuildingTypeForm, setShowBuildingTypeForm] = useState(false);
  const isInitialized = useRef(false);
  const scrollToRef = useRef(null); // Ref for the scrollable container

  useEffect(() => {
    if (!isInitialized.current) {
      console.log("+ HomePage");
      isInitialized.current = true;
    }

    return () => {
      // TODO: Cleanup code
    };
  }, []); // Empty dependency array ensures this runs once after initial mount

  const navigate = useNavigate();

  const handleFileUpload = (fileName) => {
    navigate("/waiting");
  };

  const selectBuildingType = (event) => {
    let target = event.target;
    var button = $(target);
    if (!button.is("button")) {
      // It is possible to click on something else in the button (eg. '<span>')
      button = button.closest("button");
    }
    let buildingType = button.data("type");
    let isSupported = button.data("supported");

    if (buildingType === currentBuildingType) {
      // Selected the same type again - hide
      setShowFileUpload(false);
      setShowBuildingTypeForm(false);
      buildingType = null;
    } else {
      // State change
      if (currentBuildingType !== null) {
        // Clear previous selection
        setShowFileUpload(false);
        setShowBuildingTypeForm(false);
      }
      isSupported ? setShowFileUpload(true) : setShowBuildingTypeForm(true);
    }

    setCurrentBuildingType(buildingType);
  };

  const resetSelection = () => {
    setShowFileUpload(false);
    setShowBuildingTypeForm(false);
    setCurrentBuildingType(null);
  };

  // Scroll to the FileUploadView or BuildingTypeForm when they are displayed
  useEffect(() => {
    if ((showFileUpload || showBuildingTypeForm) && scrollToRef.current) {
      scrollToRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showFileUpload, showBuildingTypeForm]);

  return (
    <div id={styles.homePageContainer}>
      <img src={logo} alt="logo" id="cisco-logo" />
      <div id={styles.home} className={styles.container}>
        <div>
          {currentBuildingType === null ? (
            <h1>
              Transform Your Buildings with <br />
              <span>Cisco Spaces AI Maps</span>
            </h1>
          ) : (
            <h1 className={styles.secondaryTitle}>
              Unlock the power of <br /> AI Mapping!
            </h1>
          )}
        </div>
        <p className={styles.description}>
          Simply upload your floor plan and watch as <span>Cisco Spaces</span>{" "}
          turns it <br />
          into an interactive 3D Map in just minutes.
        </p>

        {currentBuildingType === null ? (
          <>
            <div id={styles.backgroundImageContainer}></div>
            <TypeSelection onSelect={selectBuildingType} />
          </>
        ) : (
          <div className={styles.uploadStepContainer} ref={scrollToRef}>
            <div>
              <h6>You selected</h6>
              <div className={styles.selectedButton}>
                <div>
                  {currentBuildingType.charAt(0).toUpperCase() +
                    currentBuildingType.slice(1)}
                </div>

                <div
                  className={styles.closeIcon}
                  role="button"
                  onClick={resetSelection}
                >
                  <img src={closeIcon} alt="close" />
                </div>
              </div>
            </div>
            <AnimatePresence>
              {showFileUpload && (
                <FileUploadView onFileUploaded={handleFileUpload} />
              )}
              {showBuildingTypeForm && <BuildingTypeForm />}
            </AnimatePresence>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
